import $ from 'jquery'
$(document).ready(function() {
	/*
	 * Customise select
	 */
	//https://selectric.js.org/
	$('select').selectric()

	//date picker
	$('.date-picker input').datetimepicker({
		timepicker: false,
		format: 'd M Y',
		scrollInput: false
	})

	//time picker
	$('.time-picker input').datetimepicker({
		datepicker: false,
		format: 'h:ia',
		step: 30,
		scrollInput: false,
		validateOnBlur: false,
		defaultTime: '09:00am',
		onChangeDateTime: function(dp, $input) {
			//fix a bug
			let val = $input.val()
			let h = val.split(':')[0]
			let m = val.split(':')[1].substring(0, 2)
			let apm = val.split(':')[1].substring(2)
			if (h == '12' && apm == 'am') {
				$input.val('00:' + m + apm)
			}
		}
	})

	$('.time-picker input , .date-picker input').attr('autocomplete', 'off')

	//customised check box
	const checkboxs = $('.gform_wrapper input[type=checkbox]')

	checkboxs.each(function() {
		$(this).wrap('<div class="customCheckbox"></div>')
		$(this).before('<span><i class="fa fa-check" aria-hidden="true"></i></span>')
		$(this)
			.parent()
			.toggleClass('customCheckboxChecked', $(this).is(':checked'))
	})

	checkboxs.change(function() {
		$(this)
			.parent()
			.toggleClass('customCheckboxChecked', $(this).is(':checked'))
	})

	//customised radio
	const radio = $('.gform_wrapper input[type=radio]')

	radio.each(function() {
		$(this).wrap('<div class="customCheckbox radio"></div>')
		$(this).before('<span><i class="fa fa-check" aria-hidden="true"></i></span>')
		if ($(this).is(':checked')) {
			$(this)
				.parent()
				.addClass('customCheckboxChecked')
			$(this)
				.parent()
				.parent()
				.siblings()
				.find('.customCheckbox')
				.removeClass('customCheckboxChecked')
		}
	})

	radio.change(function() {
		if ($(this).is(':checked')) {
			$(this)
				.parent()
				.addClass('customCheckboxChecked')
			$(this)
				.parent()
				.parent()
				.siblings()
				.find('.customCheckbox')
				.removeClass('customCheckboxChecked')
		}
	})

	//Custom file upload widget;
	//Based on gravity form
	$('.gfield input[type="file"]:not([multiple])').each(function() {
		//Clear stored file
		$(this).val('')
		const inputID = $(this).attr('id')
		const targetGfield = $(this).closest('.gfield')
		targetGfield.addClass('has-single-file-input')
		$(
			'<label class="fw-file-upload-label btn btn-blue" for="' +
				inputID +
				'"><i class="fa fa-upload"></i><span class="file-input-text">Select a file</span></label>'
		).insertBefore($(this))
		$(this).on('change', function() {
			if (
				$(this)
					.siblings('.validation_message')
					.text() ||
				!$(this).val()
			) {
				$(this)
					.siblings('.fw-file-upload-label')
					.find('.file-input-text')
					.text('Select a file')
			} else {
				$(this)
					.siblings('.fw-file-upload-label')
					.find('.file-input-text')
					.text(
						$(this)
							.val()
							.split('\\')
							.slice(-1)[0]
					)
			}
		})
	})

	//Scroll to the Gravity form once the form was submitted.
	if ($('.gform_validation_errors').length) {
		setTimeout(function() {
			$('html, body').animate({ scrollTop: $('.gform_wrapper').offset().top }, 800)
		}, 100)
	} else if ($('.gform_confirmation_wrapper').length) {
		setTimeout(function() {
			$('html, body').animate(
				{ scrollTop: $('.gform_confirmation_wrapper ').offset().top },
				800
			)
		}, 100)
	}
})
